// Q&A API service
const API_BASE_URL = process.env.REACT_APP_API_BASE || 'https://your-function-app.azurewebsites.net/api';

const qnaService = {
  // Get all Q&As with optional filtering - alias method name
  async getAllQnas(filters = {}) {
    return this.getQnAs(filters);
  },

  // Get all Q&As with optional filtering
  async getQnAs(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.isActive !== undefined) {
        params.append('isActive', filters.isActive);
      }
      if (filters.tag) {
        params.append('tag', filters.tag);
      }
      if (filters.category) {
        params.append('category', filters.category);
      }

      const response = await fetch(`${API_BASE_URL}/qna/get?${params}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      // Handle new Firebase response format
      return result.data ? result.data : (Array.isArray(result) ? result : []);
    } catch (error) {
      console.error('Error fetching Q&As:', error);
      throw error;
    }
  },

  // Get single Q&A by ID
  async getQnA(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/qna/get?id=${id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      // Handle new Firebase response format
      return result.data ? result.data[0] : result;
    } catch (error) {
      console.error('Error fetching Q&A:', error);
      throw error;
    }
  },

  // Create new Q&A
  async createQnA(qnaData) {
    try {
      const response = await fetch(`${API_BASE_URL}/qna/post`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(qnaData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data || result;
    } catch (error) {
      console.error('Error creating Q&A:', error);
      throw error;
    }
  },

  // Update existing Q&A
  async updateQnA(id, qnaData) {
    try {
      const response = await fetch(`${API_BASE_URL}/qna/put?id=${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(qnaData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating Q&A:', error);
      throw error;
    }
  },

  // Delete Q&A
  async deleteQnA(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/qna/delete?id=${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting Q&A:', error);
      throw error;
    }
  },
};

export default qnaService;
